import { ButtonLink } from '@yingbaba/ui';
import { FileText, Users, FolderOpen, ArrowRight, CheckCircle2 } from '@yingbaba/icons';
import { siteURL } from '@yingbaba/utils';
export function ProjectsIntroduction() {
  return (
    <div className="container section project-introduction">
      <section className="project-intro-hero">
        <div>
          <span className="eyebrow">A SHARED SPACE FOR CREATION</span>
          <h1>把创作中的每一步，放在一起</h1>
          <p>从第一份需求到最后一版成片，让客户和团队围绕同一份目标、同一组任务与素材展开工作。</p>
          <div className="row wrap">
            <ButtonLink to={siteURL('work', '/projects')}>
              创建我的项目
              <ArrowRight size={16} />
            </ButtonLink>
            <ButtonLink to="/help?category=projects" variant="secondary">
              了解使用方法
            </ButtonLink>
          </div>
        </div>
        <div className="project-intro-sample" aria-label="项目工作区示意">
          <span className="tag">品牌视频创作</span>
          <h2>一个清楚的目标，一支合拍的团队</h2>
          {[
            '明确目标人群与表达内容',
            '确认时长、预算和交付时间',
            '核对音乐、素材与字体授权',
            '一起跟进任务、会议和素材版本',
          ].map((v) => (
            <p key={v}>
              <CheckCircle2 size={18} />
              {v}
            </p>
          ))}
        </div>
      </section>
      <div className="grid-3 project-intro-features">
        {[
          [
            FileText,
            '先把需求说明白',
            '记录受众、营销目的、关键信息和制作要求，导出 Word 或 PDF，让沟通有依据。',
          ],
          [
            Users,
            '和客户、团队一起推进',
            '邀请合作方加入项目，明确负责人、阶段和计划日期，会议决定直接落实为任务。',
          ],
          [
            FolderOpen,
            '让每一版素材都有来处',
            '上传新版本时保留旧稿，从其他项目复用已有素材，减少反复上传与寻找文件。',
          ],
        ].map(([Icon, title, copy]) => {
          const I = Icon as typeof FileText;
          return (
            <section className="panel" key={String(title)}>
              <I size={26} />
              <h2>{String(title)}</h2>
              <p>{String(copy)}</p>
            </section>
          );
        })}
      </div>
      <section className="panel project-intro-next">
        <div>
          <h2>从一个项目开始</h2>
          <p className="muted">填写名称即可创建，其他需求可以边沟通边完善。</p>
        </div>
        <ButtonLink to={siteURL('work', '/projects')}>
          进入项目工作台
          <ArrowRight size={16} />
        </ButtonLink>
      </section>
    </div>
  );
}
